import {BtnModificarDireccion, ContainerDireccion} from '../../ui';
import {Link} from 'react-router-dom';

// TODO: refactor
export const ConfirmAddressUI = ({ address }) => {
  return (
      <ContainerDireccion>
        <p>{address.mainInfo}</p>
        <p><b>Nombre: </b>{address.name}</p>
        <p><b>Código postal: </b>{address.zip || 'N/A'}</p>
        <p><b>Provincia ó región: </b>{address.country || 'N/A'}</p>

        <Link to={'/cuenta/direcciones'}>
          <BtnModificarDireccion>
            Modificar dirección de entrega
          </BtnModificarDireccion>
        </Link>
      </ContainerDireccion>

  );
};